<template>
    <div>
        <div class="form-inline style-item">
            <div v-if="!isFeedback" class="form-group">
                <label
                    :for="`textAttributesl${name}`"
                    class="custom style-label-md text-attribute"
                    >{{
                        `${$t('labelTextAttribute')}${$t('labelOptional')}`
                    }}</label
                >
                <x-select
                    v-if="showTextAttribute"
                    :id="`textAttributesl${name}`"
                    :name="`textAttributesl${name}`"
                    v-model="selectedTextAttribute"
                    @selected="$_textAttributeSelected($event)"
                    :options="
                        $_convertToValueTextPair(
                            textAttributeOptions,
                            'attribute',
                            'attribute'
                        )
                    "
                    :simpleMode="true"
                >
                </x-select>
                <span v-else>{{ $t('labelSeeAdvancedLabels') }}</span>
            </div>
        </div>
        <!-- Show text styling options when there is a textAttribute or when
            textAttribute should not be shown because there is an advanced label -->
        <div
            v-show="
                (selectedTextAttribute && selectedTextAttribute.length > 0) &&
                showTextAttribute
            ">
            <text-properties
                :themeStyle="themeStyle"
                :id="`textPropertiessl${name}`"
                :name="`textPropertiessl${name}`">
            </text-properties>
        </div>
    </div>
</template>

<script>
    import { convertToValueTextPair } from '../../../services/utilities';
    import XSelect from '../../../components/BaseComponents/x-select.vue';
    import TextProperties from './TextProperties.vue';

    export default {
        components: {
            'x-select': XSelect,
            'text-properties': TextProperties
        },

        props: {
            themeStyle: { type: Object, required: true },
            textAttributeOptions: {
                type: Array,
                required: false,
                default: () => []
            },
            textAttribute: { type: String, required: false, default: '' },
            name: { type: String, required: false, default: '' },
            showTextAttribute: { type: Boolean, required: false, default: true },
            isFeedback: { type: Boolean, required: false, default: false }
        },

        data() {
            return {
                selectedTextAttribute: this.textAttribute
            };
        },

        methods: {
            $_convertToValueTextPair(inputArray, key, value) {
                return convertToValueTextPair(inputArray, key, value);
            },

            $_textAttributeSelected(event) {
                this.selectedTextAttribute = event;
                this.$emit('update:textAttribute', event);
            }
        }
    };
</script>
